import React, {FC} from 'react';
import DocumentRequest from './DocumentRequest';

const DeliveryRequest: FC = () => (
  <DocumentRequest humanNamePlural="Bons de livraison" feminine={false} />
);

export default DeliveryRequest;
